//(function($) {
//  $(document).ready(function() {

// Easteregg #1
console.log("%cCreated by %cDreamlab", "font-size: 20px; background: -webkit-linear-gradient(#a82ec5, #31a4d3); -webkit-background-clip: text; -webkit-text-fill-color: transparent; font-family: \"Roboto\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;", "font-size: 60px; background: -webkit-linear-gradient(#a82ec5, #31a4d3); -webkit-background-clip: text; -webkit-text-fill-color: transparent; font-family: \"Roboto\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;");

//  });
//});
